<script setup>
import {Link} from "@inertiajs/vue3";
import StateEvaluation from "@/Components/Evaluation/State.vue";
import {defineProps} from "vue";
import {format} from "date-fns";
import {trans} from "laravel-vue-i18n";
import {useDateFormatting} from "@/Composables/useDateFormatting";

const props = defineProps({
    theme: {
        type: String,
        default: 'dark'
    },
    evaluation: {
        type: Object,
        required: true
    }
});

const { formatDate } = useDateFormatting();
</script>

<template>
    <Link :href="route('evaluations.show', {evaluation: evaluation})" :class="['smallEvaluationComponent', '-is-' + theme, {'-has-no-status': evaluation.status === null}]">
        <span
            class="smallEvaluationComponent-title"
            v-html="evaluation.title ?? (evaluation.repository?.name ? evaluation.repository?.name + ' - ' : '') + evaluation.third_party?.name"
        />
        <span
            v-if="evaluation.created_at"
            class="smallEvaluationComponent-date"
            v-text="evaluation.duplicated_from_evaluation_id ? trans('shared.common.from-to', {'start-date': formatDate(evaluation.created_at, 'short'), 'end-date': formatDate(evaluation.updated_at, 'short')}) : trans('shared.common.created-on') + ' ' + formatDate(evaluation.created_at, 'short')"
        />
        <StateEvaluation
            v-if="evaluation.status"
            :status="evaluation.status"
        />
    </Link>
</template>

<style lang="scss" scoped>
@use '~@/base/variables' as *;

.smallEvaluationComponent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    color: white;
    text-decoration: none;

    &.-has-no-status {
        gap: 0;
    }
    &.-is-light {
        color: $blue800;
    }
    &-title {
        font-weight: 700;
    }
    &-date {
        color: $gray500;
        margin-bottom: 10px;
    }
}
</style>
